import { Injectable } from '@angular/core';

const SERVER_ERROR_REFERENCE_TTL_MS = 5000;

interface ServerErrorReference {
  requestId: string;
  registeredAt: number;
}

/**
 * Keeps the request id of the latest 5xx response so the next error toast can show it as a
 * reference code the admin can send to the developer. Each reference is shown at most once.
 */
@Injectable({ providedIn: 'root' })
export class ServerErrorReferenceService {
  private latestReference: ServerErrorReference | null = null;

  public registerServerErrorReference(requestId: string): void {
    this.latestReference = { requestId, registeredAt: Date.now() };
  }

  public consumeRecentServerErrorReference(): string | null {
    const reference = this.latestReference;
    this.latestReference = null;

    if (!reference || Date.now() - reference.registeredAt > SERVER_ERROR_REFERENCE_TTL_MS) {
      return null;
    }
    return reference.requestId;
  }
}
